<template>
  <div ref="rightPanel"  :class="{show:show}">
    <div class="rightPanel-background" />
    <div class="rightPanel">
      <div
        class="handle-button"
        :style="{'top':buttonTop+'px','background-color': settings.theme}"
        @click="show=!show">
        <i :class="show?'el-icon-close':'el-icon-setting'" />
      </div>
      <div class="rightPanel-items">
        <slot />
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RightPanel',
  props: {
    clickNotClose: {
      default: false,
      type: Boolean
    },
    buttonTop: {
      default: 200,
      type: Number
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    ...mapState(['settings']),
    closeRightPanel () {
      return this.$store.rightPanelShow
    }
  },
  mounted () {
    this.insertToBody()
  },
  beforeDestroy () {
    const elx = this.$refs.rightPanel
    elx.remove()
  },
  watch: {
    show (value) {
      if (value && !this.clickNotClose) {
        this.addEventClick()
      }
      if (value) {
        // 在body的class样式后拼接
        document.body.classList.add('showRightPanel')
      } else {
        // 如果点击标签则移除当前样式
        document.body.classList.remove('showRightPanel')
      }
    }
  },
  methods: {
    // 添加鼠标点击事件
    addEventClick () {
      window.addEventListener('click', this.closeSidebar)
    },
    closeSidebar (evt) {
      const parent = evt.target.closest('.rightPanel')
      if (!parent) {
        this.show = false
        window.removeEventListener('click', this.closeSidebar)
      }
    },
    insertToBody () {
      const elx = this.$refs.rightPanel
      const body = document.querySelector('body')
      body.insertBefore(elx, body.firstChild)
    }
  }
}
</script>

<style lang="scss" scoped>
.showRightPanel {
  overflow: hidden;
  position: relative;
  width: calc(100% - 15px);
}

.rightPanel-background {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity .3s cubic-bezier(.7, .3, .1, 1);
  background: rgba(0, 0, 0, .2);
  z-index: -1;
}

.rightPanel {
  width: 100%;
  max-width: 260px;
  height: var(--app-viewport-height, 100dvh);
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, .05);
  transition: all .25s cubic-bezier(.7, .3, .1, 1);
  transform: translate(100%);
  background: #fff;
  z-index: 40000;
}

.show {
  transition: all .3s cubic-bezier(.7, .3, .1, 1);

  .rightPanel-background {
    z-index: 9999;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .rightPanel {
    transform: translate(0);
  }
}

.handle-button {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 200px;
  left: -42px;
  text-align: center;
  font-size: 17px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  color: #fff;
  line-height: 32px;
  i {
    font-size: 17px;
    line-height: 32px;
  }
}
.show .handle-button { left: -32px; }
@media (max-width: 700px) {
  .handle-button { left: -42px; }
  .show .handle-button { left: -32px; }
}
</style>
